var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_287",
    "data-name": "Raggruppa 287",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512.015,
    viewBox: "0 0 512 512.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_780",
    "data-name": "Tracciato 780",
    d: "M113.474,309.428,95.651,375.962,30.51,377.34a256.455,256.455,0,0,1-1.885-239.058h.014l57.994,10.632,25.4,57.646a152.793,152.793,0,0,0,1.436,102.868Z",
    fill: "#fbbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_781",
    "data-name": "Tracciato 781",
    d: "M507.527,208.188a255.911,255.911,0,0,1-91.262,247.471l-.014-.014L343.2,451.918,332.866,387.38a152.578,152.578,0,0,0,65.648-77.913h-136.9V208.188H507.527Z",
    fill: "#518ef8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_782",
    "data-name": "Tracciato 782",
    d: "M416.292,455.637l.014.014A256.091,256.091,0,0,1,30.534,377.329L113.5,309.417a152.259,152.259,0,0,0,219.408,77.955Z",
    fill: "#28b446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_783",
    "data-name": "Tracciato 783",
    d: "M419.4,58.938l-82.936,67.9a152.238,152.238,0,0,0-224.444,79.715l-83.4-68.279H28.6A256.063,256.063,0,0,1,419.4,58.938Z",
    fill: "#f14336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.588b7b48c3fef7320a51d4f2aabf9fe0.svg";
export { ForwardRef as ReactComponent };